export default "__VITE_ASSET__DMaQjUnE__"